// extracted by mini-css-extract-plugin
module.exports = {"pictureWrapper":"ImageLazy_pictureWrapper__YTLKY","loaded":"ImageLazy_loaded__XrQlN"};